import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    const measure = () => setWindowDimensions(getWindowDimensions());

    // Debounced so a slow resize drag / the iOS toolbar showing and hiding
    // doesn't re-render every consumer on every frame.
    const onResize = debounce(measure, 150);

    // Rotation: measure now, then again once the transition settles. iOS Safari
    // can report a stale window.innerWidth/innerHeight for a frame or two right
    // after `orientationchange`, so a single read here isn't enough.
    const onOrientation = () => {
      measure();
      window.setTimeout(measure, 250);
    };

    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onOrientation);
    screen.orientation?.addEventListener("change", onOrientation);

    return () => {
      onResize.cancel();
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onOrientation);
      screen.orientation?.removeEventListener("change", onOrientation);
    };
  }, []);

  return windowDimensions;
}
